import { useEffect, useRef, useState } from "react";
import { createPatchQueue, type SaveStatus } from "./patchQueue";

/** Le composant propriétaire doit être remonté avec une key lorsque l'identifiant change. */
export function usePatchQueue<T extends object>(write: (patch: Partial<T>) => Promise<void>) {
  const [status, setStatus] = useState<SaveStatus>("idle");
  const mounted = useRef(true);
  const writer = useRef(write);
  writer.current = write;
  const queue = useRef<ReturnType<typeof createPatchQueue<T>>>();
  if (!queue.current)
    queue.current = createPatchQueue<T>(
      (patch) => writer.current(patch),
      (next) => {
        if (mounted.current) setStatus(next);
      },
    );
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      void queue.current!.flush();
    };
  }, []);
  return { ...queue.current, status };
}
